module.exports = __webpack_public_path__ + "public/images/phonics.f47bebbda7a91b81fa8ab74d106f43f5.jpg";